import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  getAllEmployeeSalaryPayslipRange,
} from "../../../actions/PaySlipAction";
import { getAllEmployee } from "../../../actions/employeeAction";
import Rendertable from "./Rendertable";
import moment, { invalid } from "moment";
import dateFormat from "dateformat";
import { Row, Col, Skeleton, Collapse } from "antd";
const { Panel } = Collapse;
var formatter = new Intl.NumberFormat("en-IN");

const EmployeeAttendanceList = ({
  getAllEmployee,
  getAllEmployeeSalaryPayslipRange,
  payslipList,
  employeeDetails,
  employee,
  fromMonth,
  toMonth,
  data,
  setData,
  updatelist,
  setUpdatelist,
  componentRef,
  businessprofile,
  reload,
  setreload,
  selectedLocation,
}) => {
  const [loading, setloading] = useState(true);

  useEffect(() => {
    setloading(true);
    let promises = [];
    promises.push(getAllEmployee());
    promises.push(getAllEmployeeSalaryPayslipRange(fromMonth, toMonth));
    
    Promise.all(promises).then(() => {
      setloading(false);
    });

    setUpdatelist(true);
  }, [reload]);

  const attendacnecount = (emp) => {
    let payslips = payslipList.filter(p => p.employeeId == emp.id);
    
    if (payslips.length === 0) {
        // If no payslips found in the range, skip
        return null;
    }

    if (selectedLocation > 0 && emp.branch?.id != selectedLocation) {
        return null;
    }

    let totals = payslips.reduce((acc, p) => {
        acc.present += (p.present || 0);
        acc.absent += (p.absent || 0);
        acc.late += (p.late || 0);
        acc.overtime += (p.OverTime || 0);
        acc.leave += (p.leave || 0);
        return acc;
    }, { present: 0, absent: 0, late: 0, overtime: 0, leave: 0 });

    return (
      <tr key={emp.id}>
        <td style={{ textAlign: "left" }}>{emp.id}</td>
        <td style={{ textAlign: "left" }}>{emp.name}</td>
        <td style={{ textAlign: "left" }}>{emp.user_roleName}</td>
        <td style={{ textAlign: "left" }}>{emp.branchName}</td>
        <td>{totals.present > 0 ? totals.present : "-"}</td>
        <td>{totals.absent > 0 ? totals.absent : "-"}</td>
        <td>{totals.late > 0 ? totals.late : "-"}</td>
        <td>{totals.overtime > 0 ? parseFloat(totals.overtime).toFixed(2) : "-"}</td>
        <td>{totals.leave > 0 ? totals.leave : "-"}</td>
      </tr>
    );
  };

  if (loading) {
    return <Skeleton active />;
  } else {
    return (
      <>
        <h2 style={{ textAlign: "center" }}>Attendance Report (Salary Based)</h2>
        <p style={{ textAlign: "center" }}>
          From : <b>{fromMonth}</b> To : <b>{toMonth}</b>
        </p>
        <table className="attendacne_table" style={{ width: "100%" }}>
          <thead>
            <tr style={{ background: "#FAFAFA" }}>
                <th style={{ textAlign: "left" }}>ID</th>
                <th style={{ textAlign: "left" }}>Employee Name</th>
                <th style={{ textAlign: "left" }}>Department</th>
                <th style={{ textAlign: "left" }}>Branch</th>
                <th>Present / day</th>
                <th>Absent / day</th>
                <th>Late / day</th>
                <th>Overtime / hr</th>
                <th>Leave</th>
            </tr>
          </thead>
          <tbody>
            {employee == ""
                ? employeeDetails.map((item) => {
                return attendacnecount(item);
                })
                : employeeDetails.map((item) => {
                if (item.id == employee) return attendacnecount(item);
                })}
          </tbody>
        </table>
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    payslipList: state.employeePayslip.employeePaysliplist,
    employeeDetails: state.employee.employeelist,
    businessprofile: state.settings.businessprofile,
  };
};

export default connect(mapStateToProps, {
  getAllEmployee,
  getAllEmployeeSalaryPayslipRange,
})(EmployeeAttendanceList);
